import React, { useEffect, useRef, useState } from "react";
import Calendar from "react-calendar";
import "./CalenderChart.css";
import "react-calendar/dist/Calendar.css";
import { useLanguage } from "../../../../Providers/LanguageContext";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  reset_balance_dashboard7,
  reset_current_total_bar7,
  reset_current_total_line7,
  reset_current_vs_actual_budget_bar7,
  reset_current_vs_actual_budget_line7,
  reset_expense_bar_chart,
  reset_expense_bar_chart7,
  reset_expense_line_chart,
  reset_expense_line_chart7,
  reset_expense_per_bar_graph,
  reset_expense_per_bar_graph7,
  reset_expense_per_line_graph,
  reset_expense_per_line_graph7,
  reset_kanban_data,
  reset_kanban_data7,
  reset_open_acc_receive,
  reset_open_acc_receive7,
  reset_profit_line_chart,
  reset_profit_line_chart7,
  reset_sales_line_chart,
  reset_sales_line_chart7,
  reset_task_at_risk7,
  reset_task_complete_status7,
  reset_task_deviation_analysis7,
  reset_tax_line7,
  reset_tax_pie7,
  reset_transaction_dashboard7,
  set_balance_dashboard7,
  set_current_total_bar7,
  set_current_total_line7,
  set_current_vs_actual_budget_bar7,
  set_current_vs_actual_budget_line7,
  set_expense_bar_chart,
  set_expense_bar_chart7,
  set_expense_line_chart,
  set_expense_line_chart7,
  set_expense_per_bar_graph,
  set_expense_per_bar_graph7,
  set_expense_per_line_graph,
  set_expense_per_line_graph7,
  set_open_acc_receive,
  set_open_acc_receive7,
  set_profit_line_chart,
  set_profit_line_chart7,
  set_sales_line_chart,
  set_sales_line_chart7,
  set_task_at_risk7,
  set_task_complete_status7,
  set_task_deviation_analysis7,
  set_tax_line7,
  set_tax_pie7,
  set_transaction_dashboard7,
  toggle_Kanban_data,
  toggle_Kanban_data7,
} from "../../../../redux/reducers/favDashboardSlice";
import HttpClient from "../../../../utils/HttpClient";
import GanttChart from "../../../TaskManager/GanttChart";
import EventsCalender from "../../../TaskManager/EventsCalender";
import ViewCapitalOption from "../../../InvestmentManager/UserInvestor/ViewCapitalOption";
import DashboardManager7 from "../../dashboard/DashboardManager7";
import RiskManagement from "../../../TaskManager/RiskManagement";
import Loader from "../../../../Loader/Loader";
import RiskManagement7 from "../../../TaskManager/RiskManagement7";
import { useSelector } from "react-redux";

const CalenderChart = () => {
  const { taskCompletionStatus7, taskAtRisk7, taskDeviationAnalysis7 } =
    useSelector((state) => state?.favDashboard);
  const [value, setValue] = useState(new Date());
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { language } = useLanguage();
  const [widgetsSeven, setwidgetsSeven] = useState([]);
  const [selectedWidgetOne, setSelectedWidgetOne] = useState(null);

  const componentRef = useRef(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const fetchWidgetOneData = async () => {
    try {
      const res = await HttpClient.requestData("dashboard", "GET");
      if (res && res?.widgets && Object.keys(res?.widgets)?.length > 0) {
        setwidgetsSeven(res?.widgets?.seven || []);
      } else {
        console.log("error", res);
        setwidgetsSeven([]);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  useEffect(() => {
    fetchWidgetOneData();
  }, []);

  useEffect(() => {
    if (widgetsSeven) {
      setSelectedWidgetOne(widgetsSeven?.find((item) => item?.visible) || null);
    }
  }, [widgetsSeven]);

  const handleSelectWidget = (widget) => {
    setSelectedWidgetOne(widget);
    toast.success("Widget has been changed successfully");
    closeModal();
    setTimeout(() => {
      scrollToComponent();
    }, 100);
  };

  useEffect(() => {
    if (selectedWidgetOne) {
      // Reset all first
      dispatch(reset_kanban_data7());
      dispatch(reset_open_acc_receive7());
      dispatch(reset_expense_per_line_graph7());
      dispatch(reset_expense_per_bar_graph7());
      dispatch(reset_expense_bar_chart7());
      dispatch(reset_expense_line_chart7());
      dispatch(reset_profit_line_chart7());
      dispatch(reset_sales_line_chart7());
      dispatch(reset_task_complete_status7());
      dispatch(reset_task_deviation_analysis7());
      dispatch(reset_task_at_risk7());
      dispatch(reset_current_total_bar7());
      dispatch(reset_current_total_line7());
      dispatch(reset_current_vs_actual_budget_bar7());
      dispatch(reset_current_vs_actual_budget_line7());
      dispatch(reset_transaction_dashboard7());
      dispatch(reset_balance_dashboard7());
      dispatch(reset_tax_line7());
      dispatch(reset_tax_pie7());

      // Set based on selected widget
      switch (selectedWidgetOne?.name) {
        case "Kanban Board Analytics":
          dispatch(toggle_Kanban_data7());
          break;
        case "Open Account Receivable":
          dispatch(set_open_acc_receive7());
          break;
        case "profit vs expense (line graph)":
          dispatch(set_expense_per_line_graph7());
          break;
        case "profit vs expense (pie graph)":
          dispatch(set_expense_per_bar_graph7());
          break;
        case "Expense Bar Chart":
          dispatch(set_expense_bar_chart7());
          break;
        case "Expense Line Chart":
          dispatch(set_expense_line_chart7());
          break;
        case "Profit Line Chart":
          dispatch(set_profit_line_chart7());
          break;
        case "Sales Line Chart":
          dispatch(set_sales_line_chart7());
          break;

        case "Task Completion Status":
          dispatch(set_task_complete_status7());
          break;
        case "Task Deviation Analysis":
          dispatch(set_task_deviation_analysis7());
          break;
        case "Tasks At-Risk":
          dispatch(set_task_at_risk7());
          break;

        case "current total (bar graph)":
          dispatch(set_current_total_bar7());
          break;
        case "current total (line graph)":
          dispatch(set_current_total_line7());
          break;
        case "current actual vs budget (bar graph)":
          dispatch(set_current_vs_actual_budget_bar7());
          break;
        case "current actual vs budget (line graph)":
          dispatch(set_current_vs_actual_budget_line7());
          break;
        case "Balance dashboard":
          dispatch(set_balance_dashboard7());
          break;
        case "Transaction dashboard":
          dispatch(set_transaction_dashboard7());
          break;
        case "Tax deductible (pie graph)":
          dispatch(set_tax_pie7());
          break;
        case "Tax deductible (line graph)":
          dispatch(set_tax_line7());
          break;
        default:
          break;
      }
    }
  }, [dispatch, selectedWidgetOne]);

  const scrollToComponent = () => {
    if (componentRef.current) {
      const element = componentRef.current;
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleAddWidget = async (widget) => {
    try {
      const res = await HttpClient.requestData("dashboard", "PUT", {
        widgetId: widget?.widgetId,
      });
      if (res?.message !== "Widget not found in dashboard") {
        toast.success("Widget one has been updated successfully");
        setSelectedWidgetOne(widget);
        closeModal();
        fetchWidgetOneData();
        setTimeout(() => {
          scrollToComponent();
        }, 100);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  return (
    <>
      <div className="calendar-wrapper-mc" ref={componentRef}>
        {!selectedWidgetOne && <Loader />}
        <div className="calendar-header-mc">
          <h3 className="chart-title-mc">
            {selectedWidgetOne?.name?.toUpperCase() ||
              "Calendar"?.toUpperCase()}
          </h3>
          <i
            className="fa-regular fa-pen-to-square edit-icon-mc"
            onClick={openModal}
          ></i>
        </div>

        {/* Render the widget based on selection */}
        {selectedWidgetOne?.name === "Gantt Chart" && <GanttChart />}
        {selectedWidgetOne?.name === "Event calender" && <EventsCalender />}
        {selectedWidgetOne?.name === "Investment Manager" && (
          <ViewCapitalOption />
        )}
        {selectedWidgetOne?.name === "Kanban Board Analytics" && (
          <EventsCalender />
        )}
        {selectedWidgetOne?.name === "Open Account Receivable" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "Risk Management" && <RiskManagement />}
        {selectedWidgetOne?.name === "profit vs expense (line graph)" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "profit vs expense (pie graph)" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "Expense Bar Chart" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "Expense Line Chart" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "Profit Line Chart" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "Sales Line Chart" && (
          <DashboardManager7 />
        )}

        {selectedWidgetOne?.name === "Task Completion Status" && (
          <RiskManagement7
            taskCompleteStatus={taskCompletionStatus7}
            taskAtRisk={taskAtRisk7}
            taskDeviationAnalysis={taskDeviationAnalysis7}
          />
        )}
        {selectedWidgetOne?.name === "Task Deviation Analysis" && (
          <RiskManagement7
            taskCompleteStatus={taskCompletionStatus7}
            taskAtRisk={taskAtRisk7}
            taskDeviationAnalysis={taskDeviationAnalysis7}
          />
        )}
        {selectedWidgetOne?.name === "Tasks At-Risk" && (
          <RiskManagement7
            taskCompleteStatus={taskCompletionStatus7}
            taskAtRisk={taskAtRisk7}
            taskDeviationAnalysis={taskDeviationAnalysis7}
          />
        )}

        {selectedWidgetOne?.name === "current total (bar graph)" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "current total (line graph)" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "current actual vs budget (bar graph)" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name ===
          "current actual vs budget (line graph)" && <DashboardManager7 />}

        {selectedWidgetOne?.name === "Balance dashboard" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "Transaction dashboard" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (pie graph)" && (
          <DashboardManager7 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (line graph)" && (
          <DashboardManager7 />
        )}

        {/* Show default calendar when no widget is selected */}
        {!selectedWidgetOne && (
          <Calendar
            onChange={setValue}
            value={value}
            calendarType="US"
            prevLabel={null}
            nextLabel={null}
            showNeighboringMonth={true}
            className="react-calendar calendar-box-mc"
          />
        )}
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="gd-modal-overlay" onClick={closeModal}>
          <div
            className="gd-modal-panel chart-div-style"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="gd-modal-title">
              {language?.add_new_dashboard?.toUpperCase() ||
                "Select Widget"?.toUpperCase()}
            </h3>

            <div className="gd-modal-list">
              {widgetsSeven?.length > 0 ? (
                widgetsSeven.map((widget) => (
                  <button
                    disabled={widget?.visible}
                    className="gd-modal-row"
                    key={widget?.id}
                    onClick={() => handleAddWidget(widget)}
                    style={{
                      opacity: widget?.visible ? 0.3 : 1,
                      cursor: widget?.visible ? "not-allowed" : "pointer",
                    }}
                  >
                    <span>{widget?.name?.toUpperCase()}</span>
                    <span
                      style={{
                        opacity: widget?.visible ? 0.3 : 1,
                        cursor: widget?.visible ? "not-allowed" : "pointer",
                      }}
                      className="gd-modal-plus-btn"
                    >
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </button>
                ))
              ) : (
                <div className="gd-modal-row">
                  <span>No Widget Found ...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CalenderChart;
